import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './parentListDialog.module.scss'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Close, Person } from '@mui/icons-material'
import Desktop from '@/modules/desktopMobile/desktop'
import { ChildParent } from '@/types/Child'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface ParentListDialogProps {
    isDialogOpen: boolean
    handleCloseDialog: () => void
    parents: ChildParent[]
}

const ParentListDialog: FunctionComponent<ParentListDialogProps> = ({
    isDialogOpen,
    handleCloseDialog,
    parents
}: ParentListDialogProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    return (
        <Dialog open={isDialogOpen} handleClose={handleCloseDialog} className={styles.Dialog}>
            <DialogHeader title={t('adultList')} />
            <DialogBody className={styles.DialogBody}>
                <TableContainer className={styles.TablePlacement}>
                    <Table className={styles.Table}>
                        <TableHead className={styles.TableHeader}>
                            <TableRow>
                                <TableCell />
                                <TableCell>{t('lastname')}</TableCell>
                                <TableCell>{t('firstname')}</TableCell>
                                <Desktop>
                                    <TableCell>{t('email')}</TableCell>
                                </Desktop>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {parents.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2}>{t('noAdults')}</TableCell>
                                </TableRow>
                            ) : (
                                parents.map((parent: ChildParent) => (
                                    <TableRow
                                        key={parent.parentId}
                                        onClick={() => navigate(`?parent=${parent.parentId}`)}
                                    >
                                        <TableCell>
                                            <div className={styles.IconContainer}>
                                                <Person
                                                    className={styles.Icon}
                                                    onClick={() => navigate(`?parent=${parent.parentId}`)}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>{parent.firstname}</TableCell>
                                        <TableCell>{parent.lastname}</TableCell>
                                        <Desktop>
                                            <TableCell>
                                                {parent.email ? (
                                                    <p>{parent.email}</p>
                                                ) : (
                                                    <div className={styles.IconContainer}>
                                                        <Close className={styles.CloseIcon} />
                                                    </div>
                                                )}
                                            </TableCell>
                                        </Desktop>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleCloseDialog} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ParentListDialog
